<!--jzxz.vue  就诊须知-->
<template>
  <div class="jzxz-all-box">
    <div class="title">门诊就诊须知</div>
    <div class="content">
      <div>1.我院实行实名制预约挂号就诊，来院请携带好身份证或医保卡等相关证件<span class="red">（18周岁以下患者需由家属陪同）</span>。</div>
      <div>2.我院为精神专科医院，合并有发热的精神科患者请至我院西门急诊就诊。非精神科发热患者请至其他医院发热门诊就诊。</div>
      <div>3.精神科急危重症患者请至急诊就诊。</div>
      <div>4.门诊就诊时间，<span class="red">上午：8:00-12:00</span>（现场预约挂号截止时间11:30），<span class="red">下午：13:00-16:30</span>（现场预约挂号截止时间16:15）</div>
      <div>5.如有疑问可咨询门诊一站式服务台，电话：0512-65331356（8: 00—16:30）。</div>
      <div>衷心感谢您的理解、支持与配合！</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Jzxz',
  data() {
    return {
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="less" scoped>
.jzxz-all-box {
  background-color: #FFFFFF;
  padding: 20px;
}

.title {
  text-align: center;
  font-size: 20px;
}
.red {
  color: red;
}
.content {
  > div {
    text-indent: 2em;
    margin: 10px 0;
    font-size: 18px;
    line-height: 30px;
  }
}
</style>
